import { render, staticRenderFns } from "./RegistAlarm.vue?vue&type=template&id=346f74d8&scoped=true&"
import script from "./RegistAlarm.vue?vue&type=script&lang=js&"
export * from "./RegistAlarm.vue?vue&type=script&lang=js&"
import style0 from "./RegistAlarm.vue?vue&type=style&index=0&id=346f74d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f74d8",
  null
  
)

export default component.exports